import { createSlice } from "@reduxjs/toolkit";
import * as Actions from "../actions";
import {
  dataCrlMatrizDecisaoReducer,
  dataCrlMatrizDecisaoByFiltersReducer,
  dataCrlPedidosReducer,
  dataCrlMatrizDecisaoIndicadoresReducer,
} from "../reducers";
import { InitialState } from "./models";

const initialState: InitialState = {
  dataCrlMatrizDecisao: {
    filters: {
      listaAgingAjustada: [],
      listaAgingPrometida: [],
      listaApelidoTransportadora: [],
      listaBandeiraDescricao: [],
      listaCritico: [],
      listaIdFilial: [],
      listaReclamacao: [],
      listaTempoEmEtapa: [],
      listaTipoDeCarga: [],
      listaTipoEntregaDescricao: [],
      listaUfOrigem: [],
      listaUfDestino: [],
      listaUnidadeDeNegocioDescricao: [],
      listaAtuacao: [],
      listaSituacao: [],
    },
    dataAcoes: {
      enquadramentos: [],
      ofensores: [],
      ofensoresAgilizar: {
        atuacao: "",
        quantidade: 0,
        valor: 0,
        percentual: 0,
        ofensor: [],
      },
      ofensoresCritico: {
        atuacao: "",
        quantidade: 0,
        valor: 0,
        percentual: 0,
        ofensor: [],
      },
      ofensoresIndenizatorio: {
        atuacao: "",
        quantidade: 0,
        valor: 0,
        percentual: 0,
        ofensor: [],
      },
      ofensoresMonitorar: {
        atuacao: "",
        quantidade: 0,
        valor: 0,
        percentual: 0,
        ofensor: [],
      },
      quantidadeTotalPedidos: 0,
      valorTotalPedidos: 0,
    },
    dataIndicadores: {
      indicadorDiarioLista: [],
      cardsIndicadores: [],
    },
    isIndicadores: false,
  },
  dataCrlPedidos: {
    data: [],
    pagination: {
      page: 1,
      rowsPerPage: 15,
      totalItems: 0,
      totalPages: 0,
    }
  },
  dataCrl: {
    configTabs: {
      tabInView: 0,
      tabs: [
        {
          title: "Ações",
          index: 0,
          active: true,
          name: "acoes",
        },
        {
          title: "Indicadores",
          index: 1,
          active: true,
          name: "indicadores",
        },
        {
          title: "Pedidos filtrados",
          index: 2,
          active: false,
          name: "pedidosFiltrados",
        },
      ],
      filtersForDetails: {
        pagina: 1,
        itensPorPagina: 15,
        totalItems: 0,
        totalPages: 0,
      },
    },
  },
};

const crlSlice = createSlice({
  name: "crlApp/crl",
  initialState,
  reducers: {
    changeTabMatrizDecisao: (state, action) => {
      state.dataCrl.configTabs.tabInView = action.payload;
      if (action.payload !== 2) state.dataCrl.configTabs.tabs[2].active = false;
    },
    updateTabMatrizDecisao: (state, action) => {
      if (action.payload === 2) state.dataCrl.configTabs.tabs[2].active = true;
    },
    setIsIndicadores: (state, action) => {
      state.dataCrlMatrizDecisao.isIndicadores = action.payload;
    },
    updateFiltersDetails: (state, action) => {
      state.dataCrl.configTabs.filtersForDetails = action.payload;
    },
    clearCrlPedidos: (state) => {
      state.dataCrl.configTabs.filtersForDetails =
        initialState.dataCrl.configTabs.filtersForDetails;
      state.dataCrlPedidos.data = [];
    },
  },
  extraReducers: (builder) => {
    // Initial data matriz de decisão
    builder.addCase(
      Actions.getDataCrlMatrizDecisao.fulfilled,
      dataCrlMatrizDecisaoReducer
    );
    // Data matriz de decisão by filter
    builder.addCase(
      Actions.getDataCrlMatrizDecisaoByFilters.fulfilled,
      dataCrlMatrizDecisaoByFiltersReducer
    );
    // Inital data pedidos crl
    builder.addCase(Actions.getDataCrlPedidos.fulfilled, dataCrlPedidosReducer);
    // Indicadores
    builder.addCase(
      Actions.getDataCrlMatrizDecisaoIndicadores.fulfilled,
      dataCrlMatrizDecisaoIndicadoresReducer
    );
  },
});

export const {
  changeTabMatrizDecisao,
  updateTabMatrizDecisao,
  updateFiltersDetails,
  clearCrlPedidos,
  setIsIndicadores,
} = crlSlice.actions;

export default crlSlice.reducer;
